import { localizedString } from '@locale/index';

/**
 * use intent/agent-response , composite-attr/selected-parameter trigger-conditions
 *
 * @export
 * @enum {number}
 */
export enum Operation {
  RequireCondition = 0, // 任意值
  EqualToCondition = 1, // 等于
  NotEqualToCondition = 2, // 不等于
  GreaterThanCondition = 3, // 大于
  GreaterThanOrEqualCondition = 4, // 大于等于
  LessThanCondition = 5, // 小于
  LessThanOrEqualCondition = 6, // 小于等于
  InCondition = 7, // 存在
  NotInCondition = 8, // 不存在
  // multiple value
  SetEqualCondition = 9, // 全等
  SetContainCondition = 10, // 包含
  NotEmptySetCondition = 11, // 任意值
  SetInCondition = 12, // （多个输入框）
  UnKonwnCondition = 13, // 不确定值
  IsTypeCondition = 14 //
}

export const GetOperationName = (op: Operation) => {
  let key = '';

  switch (op) {
    case Operation.RequireCondition:
      key = 'operation_require';
      break;
    case Operation.EqualToCondition:
      key = 'operation_equal_to';
      break;
    case Operation.NotEqualToCondition:
      key = 'operation_not_equal_to';
      break;
    case Operation.GreaterThanCondition:
      key = 'operation_greater_than';
      break;
    case Operation.GreaterThanOrEqualCondition:
      key = 'operation_greater_than_or_equal';
      break;
    case Operation.LessThanCondition:
      key = 'operation_less_than';
      break;
    case Operation.LessThanOrEqualCondition:
      key = 'operation_less_than_or_equal';
      break;
    case Operation.InCondition:
      key = 'operation_in';
      break;
    case Operation.NotInCondition:
      key = 'operation_not_in';
      break;
    case Operation.SetEqualCondition:
      key = 'operation_set_eqaul';
      break;
    case Operation.NotEmptySetCondition:
      key = 'operation_require';
      break;
    case Operation.UnKonwnCondition:
      key = 'operation_unknown';
      break;
    case Operation.IsTypeCondition:
      key = 'operation_is_type';
      break;
    default:
      key = 'unknown_key';
      break;
  }

  return localizedString(key);
};

export const singleOperations = [
  Operation.RequireCondition,
  Operation.EqualToCondition,
  Operation.NotEqualToCondition,
  Operation.GreaterThanCondition,
  Operation.GreaterThanOrEqualCondition,
  Operation.LessThanCondition,
  Operation.LessThanOrEqualCondition,
  Operation.InCondition,
  Operation.NotInCondition,
  // Operation.UnKonwnCondition,
  Operation.IsTypeCondition
];

export const multiOperations = [
  Operation.SetEqualCondition,
  Operation.NotEmptySetCondition,
  // Operation.UnKonwnCondition,
  Operation.IsTypeCondition
];

export const tableOperations = [
  Operation.EqualToCondition,
  Operation.NotEqualToCondition,
  Operation.GreaterThanCondition,
  Operation.GreaterThanOrEqualCondition,
  Operation.LessThanCondition,
  Operation.LessThanOrEqualCondition
];
